module.exports = __webpack_public_path__ + "img/G27-HQ.31890ce8.png";